import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, inject, DestroyRef } from '@angular/core';

import { firstValueFrom, map, Observable } from 'rxjs';
import { mapTo, startWith } from 'rxjs/operators';
import { CommentPanelManagerService } from '../../services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-commenting-panel-button',
  templateUrl: './commenting-panel-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommentingPanelButtonComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  isLoading: boolean;

  isPanelOpened$: Observable<boolean>;
  areAllThreadsOpened$: Observable<boolean>;
  overallCommentsCount$: Observable<number>;

  @Input()
  icon = 'commenting/comment';

  @Input()
  disabled: boolean;

  @Input()
  isOnlyIcon: boolean;

  constructor(private commentPanelManagerService: CommentPanelManagerService, private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.initializeValues();

    this.overallCommentsCount$
      .pipe(
        mapTo(false),
        startWith(true),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((isLoading: boolean) => {
        this.isLoading = isLoading;
        this.cd.detectChanges();
      });
  }

  async openPanel(): Promise<void> {
    const isPanelOpened = await firstValueFrom(this.isPanelOpened$);
    const areAllThreadsDisplayed = await firstValueFrom(this.areAllThreadsOpened$);
    const isDuplicatedEvent = isPanelOpened && areAllThreadsDisplayed;

    if (this.isLoading || isDuplicatedEvent) { return; }

    this.commentPanelManagerService.displayAllThreads();
  }

  private initializeValues(): void {
    this.isPanelOpened$ = this.commentPanelManagerService.isPanelOpened();

    this.areAllThreadsOpened$ = this.commentPanelManagerService.getDisplayedSingleThreadResourceId()
      .pipe(
        map((displayedSingleThreadResourceId: string | null) => !displayedSingleThreadResourceId),
      );

    this.overallCommentsCount$ = this.commentPanelManagerService.getCommentsCount();
  }
}
